export const pagination = { limit: 40, page: 1 };
export const sortItemsCustomer = [{ sort: 'name', sortDirection: 'asc' }];
export const screenName = 'boleta-rapida';

export const productsWithTerm = ['fixedIncome', 'funds'];

export const marketTypeMap = new Map<string, string>([
  ['funds', 'fund'],
  ['equities', 'equity'],
  ['coes', 'coe'],
]);
